// 국세청 근로소득 간이세액표 (공제대상가족수 1인 기준)
// effectiveFrom: 2024-03-01
// 월급여액(비과세 및 학자금 제외) 기준. from <= 급여 < 다음 구간 from 이면 해당 구간의 tax.
// 1,060,000원 미만은 0원. 9,980,000원 이상은 마지막 구간 세액 적용 (매장 직원 급여 범위 밖 — 초과 시 원칙상 별도 산식 필요).

export const SIMPLIFIED_INCOME_TAX_BRACKETS: { from: number; tax: number }[] = [
    { from: 1060000, tax: 1040 },
    { from: 1065000, tax: 1110 },
    { from: 1070000, tax: 1180 },
    { from: 1075000, tax: 1250 },
    { from: 1080000, tax: 1320 },
    { from: 1085000, tax: 1390 },
    { from: 1090000, tax: 1460 },
    { from: 1095000, tax: 1530 },
    { from: 1100000, tax: 1600 },
    { from: 1105000, tax: 1670 },
    { from: 1110000, tax: 1740 },
    { from: 1115000, tax: 1810 },
    { from: 1120000, tax: 1880 },
    { from: 1125000, tax: 1950 },
    { from: 1130000, tax: 2020 },
    { from: 1135000, tax: 2090 },
    { from: 1140000, tax: 2160 },
    { from: 1145000, tax: 2230 },
    { from: 1150000, tax: 2300 },
    { from: 1155000, tax: 2370 },
    { from: 1160000, tax: 2440 },
    { from: 1165000, tax: 2500 },
    { from: 1170000, tax: 2570 },
    { from: 1175000, tax: 2640 },
    { from: 1180000, tax: 2710 },
    { from: 1185000, tax: 2780 },
    { from: 1190000, tax: 2850 },
    { from: 1195000, tax: 2920 },
    { from: 1200000, tax: 2990 },
    { from: 1205000, tax: 3060 },
    { from: 1210000, tax: 3130 },
    { from: 1215000, tax: 3200 },
    { from: 1220000, tax: 3270 },
    { from: 1225000, tax: 3340 },
    { from: 1230000, tax: 3410 },
    { from: 1235000, tax: 3480 },
    { from: 1240000, tax: 3550 },
    { from: 1245000, tax: 3620 },
    { from: 1250000, tax: 3700 },
    { from: 1255000, tax: 3810 },
    { from: 1260000, tax: 3910 },
    { from: 1265000, tax: 4010 },
    { from: 1270000, tax: 4120 },
    { from: 1275000, tax: 4220 },
    { from: 1280000, tax: 4320 },
    { from: 1285000, tax: 4430 },
    { from: 1290000, tax: 4530 },
    { from: 1295000, tax: 4630 },
    { from: 1300000, tax: 4740 },
    { from: 1305000, tax: 4840 },
    { from: 1310000, tax: 4940 },
    { from: 1315000, tax: 5050 },
    { from: 1320000, tax: 5150 },
    { from: 1325000, tax: 5250 },
    { from: 1330000, tax: 5360 },
    { from: 1335000, tax: 5460 },
    { from: 1340000, tax: 5560 },
    { from: 1345000, tax: 5670 },
    { from: 1350000, tax: 5770 },
    { from: 1355000, tax: 5870 },
    { from: 1360000, tax: 5980 },
    { from: 1365000, tax: 6080 },
    { from: 1370000, tax: 6180 },
    { from: 1375000, tax: 6290 },
    { from: 1380000, tax: 6390 },
    { from: 1385000, tax: 6490 },
    { from: 1390000, tax: 6600 },
    { from: 1395000, tax: 6700 },
    { from: 1400000, tax: 6800 },
    { from: 1405000, tax: 6910 },
    { from: 1410000, tax: 7010 },
    { from: 1415000, tax: 7110 },
    { from: 1420000, tax: 7210 },
    { from: 1425000, tax: 7320 },
    { from: 1430000, tax: 7420 },
    { from: 1435000, tax: 7520 },
    { from: 1440000, tax: 7630 },
    { from: 1445000, tax: 7730 },
    { from: 1450000, tax: 7830 },
    { from: 1455000, tax: 7940 },
    { from: 1460000, tax: 8040 },
    { from: 1465000, tax: 8140 },
    { from: 1470000, tax: 8250 },
    { from: 1475000, tax: 8350 },
    { from: 1480000, tax: 8450 },
    { from: 1485000, tax: 8560 },
    { from: 1490000, tax: 8660 },
    { from: 1495000, tax: 8760 },
    { from: 1500000, tax: 8920 },
    { from: 1510000, tax: 9120 },
    { from: 1520000, tax: 9330 },
    { from: 1530000, tax: 9540 },
    { from: 1540000, tax: 9740 },
    { from: 1550000, tax: 9950 },
    { from: 1560000, tax: 10160 },
    { from: 1570000, tax: 10360 },
    { from: 1580000, tax: 10570 },
    { from: 1590000, tax: 10780 },
    { from: 1600000, tax: 10980 },
    { from: 1610000, tax: 11190 },
    { from: 1620000, tax: 11400 },
    { from: 1630000, tax: 11600 },
    { from: 1640000, tax: 11810 },
    { from: 1650000, tax: 12020 },
    { from: 1660000, tax: 12220 },
    { from: 1670000, tax: 12430 },
    { from: 1680000, tax: 12640 },
    { from: 1690000, tax: 12840 },
    { from: 1700000, tax: 13050 },
    { from: 1710000, tax: 13260 },
    { from: 1720000, tax: 13460 },
    { from: 1730000, tax: 13670 },
    { from: 1740000, tax: 13880 },
    { from: 1750000, tax: 14080 },
    { from: 1760000, tax: 14290 },
    { from: 1770000, tax: 14500 },
    { from: 1780000, tax: 14700 },
    { from: 1790000, tax: 14910 },
    { from: 1800000, tax: 15110 },
    { from: 1810000, tax: 15320 },
    { from: 1820000, tax: 15530 },
    { from: 1830000, tax: 15730 },
    { from: 1840000, tax: 15940 },
    { from: 1850000, tax: 16150 },
    { from: 1860000, tax: 16350 },
    { from: 1870000, tax: 16560 },
    { from: 1880000, tax: 16770 },
    { from: 1890000, tax: 16970 },
    { from: 1900000, tax: 17180 },
    { from: 1910000, tax: 17390 },
    { from: 1920000, tax: 17590 },
    { from: 1930000, tax: 17800 },
    { from: 1940000, tax: 18010 },
    { from: 1950000, tax: 18210 },
    { from: 1960000, tax: 18420 },
    { from: 1970000, tax: 18630 },
    { from: 1980000, tax: 18880 },
    { from: 1990000, tax: 19200 },
    { from: 2000000, tax: 19520 },
    { from: 2010000, tax: 19850 },
    { from: 2020000, tax: 20170 },
    { from: 2030000, tax: 20490 },
    { from: 2040000, tax: 20810 },
    { from: 2050000, tax: 21130 },
    { from: 2060000, tax: 21450 },
    { from: 2070000, tax: 21770 },
    { from: 2080000, tax: 22090 },
    { from: 2090000, tax: 22420 },
    { from: 2100000, tax: 22740 },
    { from: 2110000, tax: 23060 },
    { from: 2120000, tax: 23380 },
    { from: 2130000, tax: 23700 },
    { from: 2140000, tax: 24020 },
    { from: 2150000, tax: 24340 },
    { from: 2160000, tax: 24660 },
    { from: 2170000, tax: 24990 },
    { from: 2180000, tax: 25310 },
    { from: 2190000, tax: 25630 },
    { from: 2200000, tax: 25950 },
    { from: 2210000, tax: 26270 },
    { from: 2220000, tax: 26590 },
    { from: 2230000, tax: 26910 },
    { from: 2240000, tax: 27240 },
    { from: 2250000, tax: 27560 },
    { from: 2260000, tax: 27880 },
    { from: 2270000, tax: 28200 },
    { from: 2280000, tax: 28520 },
    { from: 2290000, tax: 28840 },
    { from: 2300000, tax: 29160 },
    { from: 2310000, tax: 29480 },
    { from: 2320000, tax: 29810 },
    { from: 2330000, tax: 30130 },
    { from: 2340000, tax: 30450 },
    { from: 2350000, tax: 30770 },
    { from: 2360000, tax: 31090 },
    { from: 2370000, tax: 31410 },
    { from: 2380000, tax: 31730 },
    { from: 2390000, tax: 32050 },
    { from: 2400000, tax: 32380 },
    { from: 2410000, tax: 32700 },
    { from: 2420000, tax: 33020 },
    { from: 2430000, tax: 33340 },
    { from: 2440000, tax: 33660 },
    { from: 2450000, tax: 33980 },
    { from: 2460000, tax: 34300 },
    { from: 2470000, tax: 34630 },
    { from: 2480000, tax: 34950 },
    { from: 2490000, tax: 35270 },
    { from: 2500000, tax: 35600 },
    { from: 2510000, tax: 35940 },
    { from: 2520000, tax: 36280 },
    { from: 2530000, tax: 36630 },
    { from: 2540000, tax: 36970 },
    { from: 2550000, tax: 37310 },
    { from: 2560000, tax: 37650 },
    { from: 2570000, tax: 38000 },
    { from: 2580000, tax: 38340 },
    { from: 2590000, tax: 38830 },
    { from: 2600000, tax: 39690 },
    { from: 2610000, tax: 40540 },
    { from: 2620000, tax: 41400 },
    { from: 2630000, tax: 42260 },
    { from: 2640000, tax: 43110 },
    { from: 2650000, tax: 43970 },
    { from: 2660000, tax: 44820 },
    { from: 2670000, tax: 45680 },
    { from: 2680000, tax: 46540 },
    { from: 2690000, tax: 47390 },
    { from: 2700000, tax: 48250 },
    { from: 2710000, tax: 49100 },
    { from: 2720000, tax: 49960 },
    { from: 2730000, tax: 50810 },
    { from: 2740000, tax: 51670 },
    { from: 2750000, tax: 52530 },
    { from: 2760000, tax: 53380 },
    { from: 2770000, tax: 54240 },
    { from: 2780000, tax: 55090 },
    { from: 2790000, tax: 55950 },
    { from: 2800000, tax: 56800 },
    { from: 2810000, tax: 57660 },
    { from: 2820000, tax: 58520 },
    { from: 2830000, tax: 59370 },
    { from: 2840000, tax: 60230 },
    { from: 2850000, tax: 61080 },
    { from: 2860000, tax: 61940 },
    { from: 2870000, tax: 62790 },
    { from: 2880000, tax: 63650 },
    { from: 2890000, tax: 64510 },
    { from: 2900000, tax: 65360 },
    { from: 2910000, tax: 66220 },
    { from: 2920000, tax: 67070 },
    { from: 2930000, tax: 67930 },
    { from: 2940000, tax: 68780 },
    { from: 2950000, tax: 69640 },
    { from: 2960000, tax: 70500 },
    { from: 2970000, tax: 71350 },
    { from: 2980000, tax: 72210 },
    { from: 2990000, tax: 73060 },
    { from: 3000000, tax: 74350 },
    { from: 3020000, tax: 76060 },
    { from: 3040000, tax: 77770 },
    { from: 3060000, tax: 79480 },
    { from: 3080000, tax: 81190 },
    { from: 3100000, tax: 82900 },
    { from: 3120000, tax: 84620 },
    { from: 3140000, tax: 86330 },
    { from: 3160000, tax: 88040 },
    { from: 3180000, tax: 89750 },
    { from: 3200000, tax: 91460 },
    { from: 3220000, tax: 93170 },
    { from: 3240000, tax: 95430 },
    { from: 3260000, tax: 97880 },
    { from: 3280000, tax: 100320 },
    { from: 3300000, tax: 102770 },
    { from: 3320000, tax: 105210 },
    { from: 3340000, tax: 107660 },
    { from: 3360000, tax: 110100 },
    { from: 3380000, tax: 112550 },
    { from: 3400000, tax: 114990 },
    { from: 3420000, tax: 117440 },
    { from: 3440000, tax: 119880 },
    { from: 3460000, tax: 122330 },
    { from: 3480000, tax: 124770 },
    { from: 3500000, tax: 127220 },
    { from: 3520000, tax: 129660 },
    { from: 3540000, tax: 132110 },
    { from: 3560000, tax: 134550 },
    { from: 3580000, tax: 137000 },
    { from: 3600000, tax: 139440 },
    { from: 3620000, tax: 141890 },
    { from: 3640000, tax: 144330 },
    { from: 3660000, tax: 146780 },
    { from: 3680000, tax: 149220 },
    { from: 3700000, tax: 151670 },
    { from: 3720000, tax: 154110 },
    { from: 3740000, tax: 156560 },
    { from: 3760000, tax: 163920 },
    { from: 3780000, tax: 166590 },
    { from: 3800000, tax: 169260 },
    { from: 3820000, tax: 171930 },
    { from: 3840000, tax: 174600 },
    { from: 3860000, tax: 177270 },
    { from: 3880000, tax: 179940 },
    { from: 3900000, tax: 182610 },
    { from: 3920000, tax: 185280 },
    { from: 3940000, tax: 187950 },
    { from: 3960000, tax: 190620 },
    { from: 3980000, tax: 193290 },
    { from: 4000000, tax: 195960 },
    { from: 4020000, tax: 198630 },
    { from: 4040000, tax: 201300 },
    { from: 4060000, tax: 203970 },
    { from: 4080000, tax: 206640 },
    { from: 4100000, tax: 209310 },
    { from: 4120000, tax: 211980 },
    { from: 4140000, tax: 214650 },
    { from: 4160000, tax: 217320 },
    { from: 4180000, tax: 219990 },
    { from: 4200000, tax: 222660 },
    { from: 4220000, tax: 225330 },
    { from: 4240000, tax: 228000 },
    { from: 4260000, tax: 230670 },
    { from: 4280000, tax: 233340 },
    { from: 4300000, tax: 236010 },
    { from: 4320000, tax: 238680 },
    { from: 4340000, tax: 241350 },
    { from: 4360000, tax: 244020 },
    { from: 4380000, tax: 246690 },
    { from: 4400000, tax: 249360 },
    { from: 4420000, tax: 252030 },
    { from: 4440000, tax: 254700 },
    { from: 4460000, tax: 257370 },
    { from: 4480000, tax: 260040 },
    { from: 4500000, tax: 262840 },
    { from: 4520000, tax: 265650 },
    { from: 4540000, tax: 268450 },
    { from: 4560000, tax: 271260 },
    { from: 4580000, tax: 276560 },
    { from: 4600000, tax: 279370 },
    { from: 4620000, tax: 282170 },
    { from: 4640000, tax: 284980 },
    { from: 4660000, tax: 287780 },
    { from: 4680000, tax: 290590 },
    { from: 4700000, tax: 293390 },
    { from: 4720000, tax: 296200 },
    { from: 4740000, tax: 299000 },
    { from: 4760000, tax: 301810 },
    { from: 4780000, tax: 304610 },
    { from: 4800000, tax: 307420 },
    { from: 4820000, tax: 310220 },
    { from: 4840000, tax: 313030 },
    { from: 4860000, tax: 315830 },
    { from: 4880000, tax: 318640 },
    { from: 4900000, tax: 321440 },
    { from: 4920000, tax: 324250 },
    { from: 4940000, tax: 327050 },
    { from: 4960000, tax: 329860 },
    { from: 4980000, tax: 332660 },
    { from: 5000000, tax: 335470 },
    { from: 5020000, tax: 338270 },
    { from: 5040000, tax: 341080 },
    { from: 5060000, tax: 343880 },
    { from: 5080000, tax: 346690 },
    { from: 5100000, tax: 349490 },
    { from: 5120000, tax: 352300 },
    { from: 5140000, tax: 355100 },
    { from: 5160000, tax: 357910 },
    { from: 5180000, tax: 360710 },
    { from: 5200000, tax: 363520 },
    { from: 5220000, tax: 366320 },
    { from: 5240000, tax: 369130 },
    { from: 5260000, tax: 371930 },
    { from: 5280000, tax: 374740 },
    { from: 5300000, tax: 377540 },
    { from: 5320000, tax: 380350 },
    { from: 5340000, tax: 383150 },
    { from: 5360000, tax: 385960 },
    { from: 5380000, tax: 388760 },
    { from: 5400000, tax: 391570 },
    { from: 5420000, tax: 394370 },
    { from: 5440000, tax: 397180 },
    { from: 5460000, tax: 399980 },
    { from: 5480000, tax: 402790 },
    { from: 5500000, tax: 405590 },
    { from: 5520000, tax: 408400 },
    { from: 5540000, tax: 411200 },
    { from: 5560000, tax: 414010 },
    { from: 5580000, tax: 416810 },
    { from: 5600000, tax: 419620 },
    { from: 5620000, tax: 422420 },
    { from: 5640000, tax: 425230 },
    { from: 5660000, tax: 428030 },
    { from: 5680000, tax: 430840 },
    { from: 5700000, tax: 433640 },
    { from: 5720000, tax: 436450 },
    { from: 5740000, tax: 439250 },
    { from: 5760000, tax: 442060 },
    { from: 5780000, tax: 444860 },
    { from: 5800000, tax: 447670 },
    { from: 5820000, tax: 450470 },
    { from: 5840000, tax: 470380 },
    { from: 5860000, tax: 475720 },
    { from: 5880000, tax: 478690 },
    { from: 5900000, tax: 483220 },
    { from: 5920000, tax: 487760 },
    { from: 5940000, tax: 492300 },
    { from: 5960000, tax: 496830 },
    { from: 5980000, tax: 501370 },
    { from: 6000000, tax: 505900 },
    { from: 6020000, tax: 510440 },
    { from: 6040000, tax: 514980 },
    { from: 6060000, tax: 519510 },
    { from: 6080000, tax: 524050 },
    { from: 6100000, tax: 528580 },
    { from: 6120000, tax: 533120 },
    { from: 6140000, tax: 537660 },
    { from: 6160000, tax: 542190 },
    { from: 6180000, tax: 546730 },
    { from: 6200000, tax: 551260 },
    { from: 6220000, tax: 555800 },
    { from: 6240000, tax: 560340 },
    { from: 6260000, tax: 564870 },
    { from: 6280000, tax: 569410 },
    { from: 6300000, tax: 573940 },
    { from: 6320000, tax: 578480 },
    { from: 6340000, tax: 583020 },
    { from: 6360000, tax: 587550 },
    { from: 6380000, tax: 592090 },
    { from: 6400000, tax: 596620 },
    { from: 6420000, tax: 601160 },
    { from: 6440000, tax: 605700 },
    { from: 6460000, tax: 610230 },
    { from: 6480000, tax: 614770 },
    { from: 6500000, tax: 619300 },
    { from: 6520000, tax: 623840 },
    { from: 6540000, tax: 628380 },
    { from: 6560000, tax: 632910 },
    { from: 6580000, tax: 637450 },
    { from: 6600000, tax: 641980 },
    { from: 6620000, tax: 646520 },
    { from: 6640000, tax: 651060 },
    { from: 6660000, tax: 655590 },
    { from: 6680000, tax: 660130 },
    { from: 6700000, tax: 664660 },
    { from: 6720000, tax: 669200 },
    { from: 6740000, tax: 673740 },
    { from: 6760000, tax: 678270 },
    { from: 6780000, tax: 682810 },
    { from: 6800000, tax: 687340 },
    { from: 6820000, tax: 691880 },
    { from: 6840000, tax: 696420 },
    { from: 6860000, tax: 700950 },
    { from: 6880000, tax: 705490 },
    { from: 6900000, tax: 710020 },
    { from: 6920000, tax: 714560 },
    { from: 6940000, tax: 719100 },
    { from: 6960000, tax: 723630 },
    { from: 6980000, tax: 728170 },
    { from: 7000000, tax: 732700 },
    { from: 7020000, tax: 737240 },
    { from: 7040000, tax: 741780 },
    { from: 7060000, tax: 746310 },
    { from: 7080000, tax: 750850 },
    { from: 7100000, tax: 755380 },
    { from: 7120000, tax: 759920 },
    { from: 7140000, tax: 764460 },
    { from: 7160000, tax: 768990 },
    { from: 7180000, tax: 773530 },
    { from: 7200000, tax: 778060 },
    { from: 7220000, tax: 782600 },
    { from: 7240000, tax: 787140 },
    { from: 7260000, tax: 791670 },
    { from: 7280000, tax: 796210 },
    { from: 7300000, tax: 800740 },
    { from: 7320000, tax: 805280 },
    { from: 7340000, tax: 809820 },
    { from: 7360000, tax: 814350 },
    { from: 7380000, tax: 818890 },
    { from: 7400000, tax: 823420 },
    { from: 7420000, tax: 827960 },
    { from: 7440000, tax: 832500 },
    { from: 7460000, tax: 837030 },
    { from: 7480000, tax: 841570 },
    { from: 7500000, tax: 846100 },
    { from: 7520000, tax: 850640 },
    { from: 7540000, tax: 855180 },
    { from: 7560000, tax: 859710 },
    { from: 7580000, tax: 864250 },
    { from: 7600000, tax: 868780 },
    { from: 7620000, tax: 873320 },
    { from: 7640000, tax: 877860 },
    { from: 7660000, tax: 882390 },
    { from: 7680000, tax: 886930 },
    { from: 7700000, tax: 891460 },
    { from: 7720000, tax: 896000 },
    { from: 7740000, tax: 900540 },
    { from: 7760000, tax: 905070 },
    { from: 7780000, tax: 909610 },
    { from: 7800000, tax: 914140 },
    { from: 7820000, tax: 918680 },
    { from: 7840000, tax: 923220 },
    { from: 7860000, tax: 927750 },
    { from: 7880000, tax: 932290 },
    { from: 7900000, tax: 936820 },
    { from: 7920000, tax: 941360 },
    { from: 7940000, tax: 945900 },
    { from: 7960000, tax: 950430 },
    { from: 7980000, tax: 954970 },
    { from: 8000000, tax: 959500 },
    { from: 8020000, tax: 964040 },
    { from: 8040000, tax: 968580 },
    { from: 8060000, tax: 973110 },
    { from: 8080000, tax: 977650 },
    { from: 8100000, tax: 982180 },
    { from: 8120000, tax: 986720 },
    { from: 8140000, tax: 991260 },
    { from: 8160000, tax: 995790 },
    { from: 8180000, tax: 1000330 },
    { from: 8200000, tax: 1004860 },
    { from: 8220000, tax: 1009400 },
    { from: 8240000, tax: 1013940 },
    { from: 8260000, tax: 1018470 },
    { from: 8280000, tax: 1023010 },
    { from: 8300000, tax: 1027540 },
    { from: 8320000, tax: 1032080 },
    { from: 8340000, tax: 1036740 },
    { from: 8360000, tax: 1041420 },
    { from: 8380000, tax: 1046100 },
    { from: 8400000, tax: 1050780 },
    { from: 8420000, tax: 1055460 },
    { from: 8440000, tax: 1060140 },
    { from: 8460000, tax: 1064820 },
    { from: 8480000, tax: 1069500 },
    { from: 8500000, tax: 1074180 },
    { from: 8520000, tax: 1078860 },
    { from: 8540000, tax: 1083540 },
    { from: 8560000, tax: 1088220 },
    { from: 8580000, tax: 1092900 },
    { from: 8600000, tax: 1097580 },
    { from: 8620000, tax: 1102260 },
    { from: 8640000, tax: 1106940 },
    { from: 8660000, tax: 1111620 },
    { from: 8680000, tax: 1116300 },
    { from: 8700000, tax: 1120980 },
    { from: 8720000, tax: 1125660 },
    { from: 8740000, tax: 1130340 },
    { from: 8760000, tax: 1135020 },
    { from: 8780000, tax: 1139700 },
    { from: 8800000, tax: 1144380 },
    { from: 8820000, tax: 1149060 },
    { from: 8840000, tax: 1153740 },
    { from: 8860000, tax: 1158420 },
    { from: 8880000, tax: 1163100 },
    { from: 8900000, tax: 1167780 },
    { from: 8920000, tax: 1172460 },
    { from: 8940000, tax: 1177140 },
    { from: 8960000, tax: 1181820 },
    { from: 8980000, tax: 1186500 },
    { from: 9000000, tax: 1191180 },
    { from: 9020000, tax: 1195860 },
    { from: 9040000, tax: 1200540 },
    { from: 9060000, tax: 1205220 },
    { from: 9080000, tax: 1209900 },
    { from: 9100000, tax: 1214580 },
    { from: 9120000, tax: 1219260 },
    { from: 9140000, tax: 1223940 },
    { from: 9160000, tax: 1228620 },
    { from: 9180000, tax: 1233300 },
    { from: 9200000, tax: 1237980 },
    { from: 9220000, tax: 1244640 },
    { from: 9240000, tax: 1251470 },
    { from: 9260000, tax: 1258290 },
    { from: 9280000, tax: 1265120 },
    { from: 9300000, tax: 1271940 },
    { from: 9320000, tax: 1278770 },
    { from: 9340000, tax: 1285590 },
    { from: 9360000, tax: 1292420 },
    { from: 9380000, tax: 1299240 },
    { from: 9400000, tax: 1306070 },
    { from: 9420000, tax: 1312890 },
    { from: 9440000, tax: 1319720 },
    { from: 9460000, tax: 1326540 },
    { from: 9480000, tax: 1333370 },
    { from: 9500000, tax: 1340190 },
    { from: 9520000, tax: 1347020 },
    { from: 9540000, tax: 1353840 },
    { from: 9560000, tax: 1360670 },
    { from: 9580000, tax: 1367490 },
    { from: 9600000, tax: 1374320 },
    { from: 9620000, tax: 1381140 },
    { from: 9640000, tax: 1387970 },
    { from: 9660000, tax: 1394790 },
    { from: 9680000, tax: 1401620 },
    { from: 9700000, tax: 1408440 },
    { from: 9720000, tax: 1415270 },
    { from: 9740000, tax: 1422090 },
    { from: 9760000, tax: 1428920 },
    { from: 9780000, tax: 1435740 },
    { from: 9800000, tax: 1442570 },
    { from: 9820000, tax: 1449390 },
    { from: 9840000, tax: 1456220 },
    { from: 9860000, tax: 1463040 },
    { from: 9880000, tax: 1469870 },
    { from: 9900000, tax: 1476690 },
    { from: 9920000, tax: 1483520 },
    { from: 9940000, tax: 1490340 },
    { from: 9960000, tax: 1497170 },
    { from: 9980000, tax: 1503990 },
];

// 월급여액으로 간이세액표 근로소득세 조회
export const calculateSimplifiedIncomeTax = (monthlySalary: number): number => {

    if (monthlySalary < 1060000) {
        return 0;
    }

    var tax = 0;

    for (const bracket of SIMPLIFIED_INCOME_TAX_BRACKETS) {
        if (monthlySalary >= bracket.from) {
            tax = bracket.tax;
        } else {
            break;
        }
    }

    return tax;
};
